import React from 'react';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import {CreateSchemaContext} from "./context/CreateSchemaContext";
import SchemaMetadataWidget from "../../widgets/schema-metadata/SchemaMetadataWidget";
import SchemaInformationWidget from "../../widgets/schema-information/SchemaInformationWidget";
import {WizardStepProps} from "../../wizard/Wizard";
import {UnsavedChangesConfirmation} from "../../../common/NavigationConfirmation";
import {CreateSchemaWizardLeavingConfirmationMessage} from "./CreateSchemaWizard";
import OpenSchemaAction from "../actions/OpenSchemaAction";
import Loader from "../../loader/Loader";

class ActivateSchemaStep extends React.Component<WizardStepProps> {

  static contextType = CreateSchemaContext;

  onActivate = () => {
    const result = this.context.activateSchema(this.context.schemaId);
    return this.props.next(result);
  };

  onSkipActivation = () => {
    return this.props.next(true);
  };

  render() {
    const {schemaId, isRequestRunning} = this.context;
    return (
      <>
        <Container className="ActivateSchemaStep no-padding" fluid>
          <Row className="pb-3">
            <Col>
              <div className="StepActions">
                <OpenSchemaAction schemaId={schemaId}
                                  standardButton={true}
                                  disabled={isRequestRunning}/>
                <Button className="activate-schema next-btn"
                        disabled={!this.context.permissions?.canBind || isRequestRunning}
                        onClick={this.onActivate}
                        title={this.context.permissions?.canBind ? "Activate Schema" : "Activate schema is forbidden"}>
                  Activate
                </Button>
                <Button className="skip-activation"
                        disabled={isRequestRunning}
                        onClick={this.onSkipActivation}
                        title="Skip activation">
                  Skip activation
                </Button>
                {isRequestRunning ? <Loader/> : null}
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <SchemaMetadataWidget schema={this.context.schema} loading={this.context.loading}/>
            </Col>
            <Col>
              <SchemaInformationWidget schema={this.context.schema} loading={this.context.loading}/>
            </Col>
          </Row>
        </Container>
        <UnsavedChangesConfirmation when={true}
                                    message={CreateSchemaWizardLeavingConfirmationMessage}/>
      </>
    );
  }
}

export default ActivateSchemaStep;
